import script from "./ExtensionPromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtensionPromptModal.vue?vue&type=script&setup=true&lang=js"

import "./ExtensionPromptModal.vue?vue&type=style&index=0&id=2da5fef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da5fef0"]])

export default __exports__